import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../../util/assets';
import Button from '../../../../../../../../../components/global/Button';
import { REQUIRES_PRINT_PACKAGE_ALERT_MODAL } from '../RequiresPrintPackageAlert';
import useOpenModal from '../../../../../../../../../hooks/useOpenModal';
import WaldogramConfiguratorContainerModal, {
  WALDOGRAM_CONFIGURATOR_CONTAINER_MODAL,
} from '../../../../../../../../web-gallery/containers/waldograms/WaldogramConfiguratorContainerModal';
import useCloseModal from '../../../../../../../../../hooks/useCloseModal';

const propTypes = {
  className: PropTypes.string,
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
    album: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const EventCollagesOption = ({
  className,
  albumMembershipGroup,
  readOnly,
  disabled,
  onClose,
}) => {
  const openModal = useOpenModal();
  const closeModal = useCloseModal();

  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-waldograms': true,
  });

  return (
    <Fragment>
      <div className={classes} data-testid="waldograms-option">
        <div className="purchasing-option-item-thumb">
          <img
            width={60}
            src={getAsset('/camper_postcard_image.webp')}
            alt=""
          />
        </div>

        <div className="purchasing-option-item-content-wrap">
          <span className="purchasing-option-item-title">
            Send a card to your camper today!
          </span>

          {!readOnly && (
            <Button
              className={classNames({
                'purchasing-options-item-btn': true,
                'mt-2': true,
              })}
              data-testid="btn-event-collages-shop"
              onClick={() => {
                if (disabled) {
                  openModal(REQUIRES_PRINT_PACKAGE_ALERT_MODAL, {
                    name: 'Sending cards b ',
                  });
                  return;
                }

                openModal(WALDOGRAM_CONFIGURATOR_CONTAINER_MODAL);
              }}
            >
              Configure &amp; Buy
            </Button>
          )}
          {readOnly && (
            <div data-testid="collages-price-list">
              <div className="d-flex flex-column mt-1">
                <span className="text-sm purchasing-option-item-title">
                  Send a card to your camper
                </span>
              </div>
            </div>
          )}
        </div>
        <WaldogramConfiguratorContainerModal
          albumId={albumMembershipGroup?.album?.id}
          onGoBack={() => {
            closeModal(WALDOGRAM_CONFIGURATOR_CONTAINER_MODAL);
            onClose();
          }}
        />
      </div>
    </Fragment>
  );
};

EventCollagesOption.propTypes = propTypes;

export default EventCollagesOption;
